<template>
  <b-link @click="showSubjectModal()">
    Subject History
    <i class="fas fa-notes-medical"></i>
  </b-link>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    subjectId: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions("dialog", ["toggleSubjectModal"]),
    showSubjectModal: function() {
      this.toggleSubjectModal(this.subjectId);
    },
  },
};
</script>
